import _slicedToArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "loading-indicator"
};
var _hoisted_2 = {
  key: 1,
  class: "no-more-data"
};
import { reactive, ref, toRefs, onMounted, watch, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { MessagePlugin } from 'tdesign-vue-next';
import FilePreviewDialog from './FilePreviewDialog.vue';
import SynthesisList from '@/views/stuSpaceInfo/SynthesisList';
import { getActivityList } from '@/api/spaceInfo.js';
import bus from '@/util/bus.js';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  props: {
    visitorType: {
      // 0:游客 1:自己(自己访问自己空间仍为个人视角)  2:公开
      type: Number,
      default: -1
    },
    useToHome: {
      // 用于首页
      type: Boolean,
      default: false
    },
    showScope: {
      type: String
    },
    curUserId: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      useToHome = _toRefs.useToHome,
      showScope = _toRefs.showScope,
      visitorType = _toRefs.visitorType,
      curUserId = _toRefs.curUserId;
    var list = ref([]); //列表内容
    var page = reactive({
      size: 12,
      current: 1
    });
    var totalCount = ref(0);
    var isFinish = ref(false); //是否加载完毕
    var loading = ref(false);
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 获取accessInfo

    watch(function () {
      return useToHome.value;
    }, function (val) {
      if (val) {
        page.size = 9;
      }
    }, {
      immediate: true
    });
    var loadData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var id, query, _list$value, _yield$getActivityLis, data, _data$data, records, total, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              loading.value = true;
              id = curUserId.value || accessInfo.userId;
              query = _objectSpread(_objectSpread({}, page), {}, {
                userId: id,
                viewRadius: showScope.value,
                spaceHideFlag: props.visitorType === 1 ? null : 0
              });
              _context.p = 1;
              _context.n = 2;
              return getActivityList(query);
            case 2:
              _yield$getActivityLis = _context.v;
              data = _yield$getActivityLis.data;
              _data$data = data.data, records = _data$data.records, total = _data$data.total;
              (_list$value = list.value).push.apply(_list$value, _toConsumableArray(records ? records : []));
              totalCount.value = total;
              isFinish.value = page.current * page.size >= total;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.warning(_t.message || '获取数据失败');
            case 4:
              _context.p = 4;
              loading.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function loadData() {
        return _ref.apply(this, arguments);
      };
    }();
    var onLoad = function onLoad(val) {
      if (val) page.current++;
      loadData();
    };

    // 更新数据
    var likeOrUnlike = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              page.current = 1;
              list.value = [];
              isFinish.value = false;
              _context2.n = 1;
              return onLoad();
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function likeOrUnlike() {
        return _ref2.apply(this, arguments);
      };
    }();
    watch([visitorType, showScope, curUserId], /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref3) {
        var _ref5, newVisitorType, newValShowScope, newCurUserId;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _ref5 = _slicedToArray(_ref3, 3), newVisitorType = _ref5[0], newValShowScope = _ref5[1], newCurUserId = _ref5[2];
              if (!([0, 1, 2].includes(newVisitorType) && newValShowScope && newCurUserId)) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return likeOrUnlike();
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    var filePreviewShow = ref(false);
    var activityItem = ref({});
    // 查看详情
    var lookDetail = function lookDetail(val) {
      filePreviewShow.value = true;
      activityItem.value = val;
    };
    var containerRef = ref(null);
    onMounted(function () {
      var container = containerRef.value;
      container.addEventListener('scroll', handleScroll);
    });
    onUnmounted(function () {
      var container = containerRef.value;
      container === null || container === void 0 || container.removeEventListener('scroll', handleScroll);
    });
    var handleScroll = function handleScroll() {
      var container = containerRef.value;
      if (!container) return;
      var scrollTop = container.scrollTop,
        scrollHeight = container.scrollHeight,
        clientHeight = container.clientHeight;
      var isNearBottom = scrollHeight - (scrollTop + clientHeight) < 50;
      console.log(props.showScope, 'props.showScope');
      if (isNearBottom && !loading.value && !isFinish.value) {
        onLoad(true);
      }
    };
    return function (_ctx, _cache) {
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['active-interaction', _unref(useToHome) && 'home-active']),
        ref_key: "containerRef",
        ref: containerRef
      }, [_createElementVNode("div", {
        class: _normalizeClass(["active-list", {
          empty: !list.value.length && !loading.value && !_unref(useToHome)
        }])
      }, [_createVNode(_unref(SynthesisList), {
        isWhere: "activity",
        synthesis: list.value,
        "visitor-type": _unref(visitorType),
        loading: loading.value,
        useToHome: _unref(useToHome),
        onUpload: likeOrUnlike,
        onDetail: lookDetail
      }, null, 8, ["synthesis", "visitor-type", "loading", "useToHome"]), !_unref(useToHome) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_loading, {
        size: "small"
      })])) : _createCommentVNode("", true), isFinish.value && list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, "没有更多数据了")) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 2), _createVNode(FilePreviewDialog, {
        visible: filePreviewShow.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return filePreviewShow.value = $event;
        }),
        activityItem: activityItem.value,
        onUpdateStar: likeOrUnlike
      }, null, 8, ["visible", "activityItem"])], 2);
    };
  }
};